import './styles/main.scss'
// import {gsap} from 'gsap'
import scrollFade from './js/scrollfade'
import {colorChange,smoothScroll,backtoTop} from './js/navigation'
import {acceptance} from './js/form'
import fvBg from './assets/fv-bg.png'
import fvImg from './assets/fv-img.jpg'
import fvImssp from './assets/fv-img_sp.jpg'
import tue from './assets/TUE.svg'
import logo from './assets/kotora-logo.svg'
import aboutImg from './assets/about-img.png'
import footerImg from './assets/footer-logo.png'
import OnishiR from './assets/onishi-maru.png'
import footerBg from './assets/footer-bg.jpg'
import spNavBtn from './assets/sp-nav-btn.svg'
import sIkutame from './assets/speaker-ikutame.png'
import sHayashi from './assets/speaker-hayashi.png'
import sItani from './assets/speaker-itani.png'
import sOnishi from './assets/speaker-onishi.png'
import sAkita from './assets/speaker-akita.png'
import sShimizu from './assets/speaker-shimizu.png'
import sUshijima from './assets/panel_ushijima.png'
import sMatsubara from './assets/panel_matsubara.png'
import sAdachi from './assets/panel_adachi.png'
import sAmma from './assets/panel_amma.png'
import sAmma2 from './assets/panel_amma2.png'
import sAkamine from './assets/panel_akamine.png'
import footerBanner1 from './assets/kotoraco-banner.png'
import footerBanner2 from './assets/kotorajp-banner.png'
import logoMs from './assets/logo-ms.png'
import logoMsfg from './assets/logo-msfg.png'
import logoMarine from './assets/logo-marine.png'
import logoMh from './assets/mhg.png'
import logMon from './assets/monex.png'
import logoMsth from './assets/logo-msth.png'
import logoMufg from './assets/logo-mufg.jpg'
import logoMufg2 from './assets/logo-mufg2.png'
import logoPwC from './assets/logo-pwc.jpg'
import logoPwC2 from './assets/logo-pwc2.jpg'
import logoEY from './assets/logo-ey.png'
import logoKPMG from './assets/logo-kpmg.png'
import logoDeloitte from './assets/logo-deloitte.png'
import completeFv from './assets/complete_fv.png'
import card_akita from './assets/cardIcon_akita.png'
import card_hayashi from './assets/cardIcon_hayashi.png'
import card_ikutame from './assets/cardIcon_ikutame.png'
import card_itani from './assets/cardIcon_itani.png'
import card_onishi from './assets/cardIcon_onishi.png'
import card_shimizu from './assets/cardIcon_shimizu.png'
import card_ushijima from './assets/cardIcon_ushijima.png'
import card_matsubara from './assets/cardIcon_matsubara.png'
import card_adachi from './assets/cardIcon_adachi.png'
import card_amma from './assets/cardIcon_amma.png'
import card_amma2 from './assets/cardIcon_amma2.png'
import card_akamine from './assets/cardIcon_akamine.png'
import aboutBg from './assets/about-bg.png'
import aboutBgsp from './assets/about-bg-sp.png'
import ogpImg from './assets/ogp.png'
import ogpImg2 from './assets/ogp-rev2.png'
import ogpImg3 from './assets/ogp-rev3.png'
import ogpImg4 from './assets/ogp-rev4.png'
scrollFade()
colorChange()
smoothScroll()
backtoTop()
acceptance()







function getComponent() {
    return import('lodash')
      .then(({ default: _ }) => {
        const element = document.createElement('div');
        element.innerHTML = _.join(['Hello', 'webpack'], ' ');
        return element;
      })
      .catch((error) => 'An error occurred while loading the component');
    }
    
    getComponent().then((component) => {
      document.body.appendChild(component);
    });